import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=a2f2e466&lang=pug"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"
import style0 from "./Info.vue?vue&type=style&index=0&id=a2f2e466&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports